export type ActiveStage = "mesh" | "slice" | "path" | null;

export const STAGE_TAG = "stageTag";

/** Names what a stage group actually is, so the scene can say so rather than be inferred. */
export const SCENE_LABEL = "sceneLabel";

export function resolveActiveStage(flags: {
  showStl: boolean;
  showSliceTemp: boolean;
  showSlicePersisted: boolean;
  showPath: boolean;
}): ActiveStage {
  if (flags.showPath) return "path";
  if (flags.showSlicePersisted || flags.showSliceTemp) return "slice";
  if (flags.showStl) return "mesh";
  return null;
}
